export class Warehouse {
    id:number = 0;
    name:string = '';
    inventory:Inventory[] = null;
    create_maintenance:boolean = true;
}

export interface Inventory{
    warehouse_id:number,
    article_id:number,
    quantity:number,
    avg_price:number,
    article_name:string,
    expense_type_id:number,
    active:boolean,
    expense_type_name:string,
    min_price:number, 
    min_price_supplier_id:number, 
    min_price_supplier_name:number, 
    max_price:number, 
    max_price_supplier_id:number, 
    max_price_supplier_name:number, 
    maintenance_warehouse:number, 
}